import { formatDate } from '@/lib/postFunctions'
import { useEffect, useState } from 'react'
import PopupComponent from '../popup/popup'
import { Media } from '@/payload-types'
import ImageComponent from '../media/imageComponent'

interface IProps {
  quote?: string
  name?: string
  reference?: string
  Date?: string
  index?: number
  image?: string | Media | null
}

export const InfamousQuoteCard = ({ quote, name, reference, Date, index, image }: IProps) => {
  const imageURL =
    typeof image === 'object'
      ? `${process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''}${
          image?.sizes?.webp?.url
        }`
      : null
  const imageAlt = typeof image === 'object' ? image?.title : null
  const [isPopoverOpen, setPopoverOpen] = useState(false)

  function ResizeFont(index: string) {
    useEffect(() => {
      const handleResize = () => {
        const maxSize = window.innerWidth > 640 ? 25 : 20
        let resize = maxSize - 1
        const element = document.getElementById(`quote-${index}`)
        const caption = document.getElementById(`caption-${index}`)
        const card = document.getElementById(`card-${index}`)
        if (element && caption && card) {
          const parent_height = parseInt(getComputedStyle(card).getPropertyValue('height'))
          const caption_height = parseInt(getComputedStyle(caption).getPropertyValue('height'))
          const padding = parent_height > 200 ? 40 : 20
          while (
            parseInt(getComputedStyle(element).getPropertyValue('height')) >
              parent_height - caption_height - padding &&
            resize > 12
          ) {
            resize -= 1
            element.style.fontSize = resize + 'px'
          }
          while (
            parseInt(getComputedStyle(element).getPropertyValue('height')) <
              parent_height - caption_height - padding &&
            resize < maxSize
          ) {
            resize += 1
            element.style.fontSize = resize + 'px'
          }
        }
        const container = document.getElementById(`carousel-box`)
        if (container != null) {
          container.style.display = 'block'
        }
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    })
  }

  function ResizeCaption(index: string) {
    useEffect(() => {
      const handleResize = () => {
        const maxSize = window.innerWidth > 640 ? 20 : 14
        let resize = maxSize - 1
        const caption = document.getElementById(`caption-${index}`)
        if (caption) {
          while (
            parseInt(getComputedStyle(caption).getPropertyValue('height')) > 40 &&
            resize > 12
          ) {
            resize -= 1
            caption.style.fontSize = resize + 'px'
          }
          while (
            parseInt(getComputedStyle(caption).getPropertyValue('height')) < 40 &&
            resize < maxSize
          ) {
            resize += 1
            caption.style.fontSize = resize + 'px'
          }
        }
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    })
  }

  ResizeFont(`${index}`)
  ResizeCaption(`${index}`)

  return (
    <>
      <div>
        <div
          id={`card-${index}`}
          className="absolute h-[160px] md:h-[226px] top-[16px] pr-8 sm:pr-12 content-center"
        >
          <div className="flex max-h-full overflow-hidden content-center">
            <div
              className={`flex max-h-full font-semibold text-base sm:text-[25px] text-gray-900 overflow-hidden !leading-normal !line-clamp-[7] sm:!line-clamp-[8] ${ResizeFont(
                `${index}`,
              )}`}
            >
              <div
                id={`quote-${index}`}
                className="flex !line-clamp-[7] sm:!line-clamp-[8] hover:underline cursor-pointer mb-5"
                onClick={() => {
                  setPopoverOpen(true)
                }}
              >{`${quote}`}</div>
            </div>
          </div>
        </div>
        <div
          id={`caption-${index}`}
          className={`pr-8 absolute bottom-[10px] sm:bottom-[12px] mt-2 font-semibold text-xs sm:text-[14px] lg:text-lg text-gray-600 ${ResizeCaption(
            `${index}`,
          )}`}
        >
          {name ? name : ''}
          {reference ? `, ${reference}` : ''}
          {Date ? `, ${formatDate(Date)}` : ''}
        </div>
      </div>

      {isPopoverOpen && imageURL && imageAlt && (
        <PopupComponent onClose={() => setPopoverOpen(false)}>
          <ImageComponent src={imageURL} alt={imageAlt} />
        </PopupComponent>
      )}
    </>
  )
}

export default InfamousQuoteCard
